import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import * as actionTypes from "../../../store/actions";
import "./TicketSideBarItem.css";

const TicketSideBarItem = (props) => {
  const onClickSideBarTicket = () => {
    props.setShouldResetTimer(true);
    props.resetNumbersStateArray();
    props.setClickedAnswerId(null);
    props.setLoadedBilet(props.ticketsArray[props.ticketId - 1]);
    if (props.closeSideBarMobile) props.closeSideBarMobile();
    window.scrollTo(0, 0);
  };

  return (
    <Link
      onClick={onClickSideBarTicket}
      className="ticket-item-link"
      to={`/${props.categoryTickets}/${props.ticketId}/1/`}
    >
      <div
        className={
          "ticket-item " +
          (props.isActiveTicketItem ? "active-ticket-item" : "")
        }
      >
        {props.header}
        {props.status === undefined ? (
          ""
        ) : props.status === false ? (
          <i
            className="check-icon red-text fas fa-times"
            title="Билет не сдан"
          ></i>
        ) : props.status === true ? (
          <i
            className="check-icon green-text fas fa-check"
            title="Билет сдан"
          ></i>
        ) : (
          ""
        )}
      </div>
    </Link>
  );
};

const mapStateToProps = (state) => {
  return {
    ticketsArray: state.ticketsReducer.ticketsArray,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetNumbersStateArray: () =>
      dispatch({ type: actionTypes.RESET_NUMBERS_STATE_ARRAY }),
    setClickedAnswerId: (id) =>
      dispatch({
        type: actionTypes.SET_CLICKED_ANSWER_ID,
        clickedAnswerId: id,
      }),
    setLoadedBilet: (loadedBilet) =>
      dispatch({
        type: actionTypes.SET_LOADED_BILET,
        loadedBilet: loadedBilet,
      }),
    setShouldResetTimer: (flag) =>
      dispatch({
        type: actionTypes.SET_SHOULD_RESET_TIMER,
        shouldResetTimer: flag,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketSideBarItem);
